import { Skeleton, SkeletonProps } from 'antd';

export type SkeletonAtomProps = SkeletonProps;

const SkeletonAtom = Skeleton;

export default SkeletonAtom;
